export { AccessControlledPageContent } from "./access-controlled-page-content";
